import { BodyText, Tag } from 'nhsuk-react-components';
import { RoutingPlans as RoutingPlansType } from 'schemas/RoutingPlan.schema.ts';
import { capitaliseFirstChar, conditionTargetToLabel, getMessagePlanStatusColour } from 'utils/formattingUtils';
import { findRoutingPlan, getCommsTarget, getRoutingPlanName } from 'utils/routingPlansUtils';
import './RoutingPlans.scss';

interface IRoutingPlansProps {
  teamRoutingPlans: RoutingPlansType;
  routingIds: string[];
}

function RoutingPlans({ teamRoutingPlans, routingIds }: IRoutingPlansProps) {
  if (routingIds.length === 0) {
    return <Tag modifier="red">To complete</Tag>;
  }

  return routingIds.map((id) => {
    const commsTarget = getCommsTarget(teamRoutingPlans, id);
    const plan = findRoutingPlan(id, teamRoutingPlans);

    return (
      <BodyText key={id} className="routing-plans__row">
        <div>
          {plan && (
            <Tag modifier={getMessagePlanStatusColour(plan.status)}>{capitaliseFirstChar(plan.status)}</Tag>
          )}
        </div>
        <div className="routing-plans__details nhsuk-body-s nhsuk-u-font-weight-bold">
          <span className="routing-plans__name">
            {getRoutingPlanName(teamRoutingPlans, id)}
          </span>
          {commsTarget && (
            <div className="nhsuk-u-secondary-text-colour">
              Target:
              {' '}
              {conditionTargetToLabel(commsTarget)}
            </div>
          )}
        </div>
      </BodyText>
    );
  });
}

export default RoutingPlans;
